import { useState } from 'react';
import '../styles.scss';
import { SettingOutlined } from '@ant-design/icons';
import { formatNumber } from '../../../services/mixin';
import MegaTable from '../../../components/MagaTableV2';

export default function ServiceMaintenanceInvoiceDetail({ stData = {} as any }) {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_total_service_detail?.list.map((col: any) => {
      if (col.field === 'present_mile_age' || col.field === 'invoice_service_total_amount' || col.field === 'repair_amount' || col.field === 'item_amount') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheServiceMaintenanceInvoiceDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "lhsc", headerName: "Loại hình SC" },
      // {
      //   field: "present_mile_age", headerName: "Số Km hiện tại", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // { field: "invoice_service_effective_get_date", headerName: "Ngày sửa chữa" },
      // { field: "receive_date", headerName: "Ngày giao xe" },
      // { field: "description", headerName: "Nội dung" },
      // {
      //   field: "invoice_service_total_amount", headerName: "Tổng tiền", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // {
      //   field: "repair_amount", headerName: "Doanh thu công lao động", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // {
      //   field: "item_amount", headerName: "Doanh thu vật tư phụ tùng", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.chitietdichvu || [] }}
            stChange={(data) => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
        </div>
      </div>
    </>
  )
}
